import React from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES: {
  code: "en" | "zh";
  labelKey: "common.languageEn" | "common.languageZh";
}[] = [
  { code: "en", labelKey: "common.languageEn" },
  { code: "zh", labelKey: "common.languageZh" },
];

export const LanguageToggle: React.FC = () => {
  const { t, i18n } = useTranslation("sharedLogin");
  const current = i18n.language;

  return (
    <div
      role="group"
      aria-label={t("common.languageToggleLabel")}
      className="flex w-fit gap-1 self-end rounded-full border-2 border-ink-12 p-1"
    >
      {LANGUAGES.map(({ code, labelKey }) => (
        <button
          key={code}
          type="button"
          onClick={() => i18n.changeLanguage(code)}
          aria-pressed={current === code}
          className={`rounded-full px-3 py-1 font-lexend text-[12px]/[16px] font-bold tracking-normal ${
            current === code ? "bg-primary-100 text-white" : "text-ink-60"
          }`}
        >
          {t(labelKey)}
        </button>
      ))}
    </div>
  );
};
